import { ErrorScreen } from '@/components/shared/ErrorScreen/ErrorScreen';
import { RegisterSteps } from '@/features/auth/components/RegisterSteps/RegisterSteps';
import { SuccessStep } from '@/features/auth/components/RegisterSteps/steps/SuccessStep/SuccessStep';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';

export const RegisterRoute = () => {
  const { t } = useTranslation('auth', { keyPrefix: 'register.welcomeStep' });
  const [searchParams] = useSearchParams();
  const invitationToken = searchParams.get('token');
  const success = searchParams.get('success');

  if (success === 'true') {
    return <SuccessStep />;
  }

  if (!invitationToken) {
    return <ErrorScreen description={t('errors.noToken')} withSeoTitle />;
  }

  return <RegisterSteps token={invitationToken} />;
};
